import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const UPDATE_QUERY = print(gql`
  mutation UpdateModalityConversion($data: UpdateModalityConversionInput!) {
    updateModalityConversion(data: $data) {
      id
    }
  }
`);

export interface UpdateGql {
  updateModalityConversion: {
    id: number;
  };
}
